import styled from '@emotion/styled';
import { theme } from '../../theme';
export const Container = styled.div `
	display: flex;
	position: ${({ position }) => position};
	width: 100vw;
	bottom: 0px;
	left: 0px;
	height: 100%;
	z-index: 1000;
	overflow: hidden;
	justify-content: center;
	align-items: center;
	transform: scale(1);
	animation: ${({ show }) => (show ? 'none' : 'hideModal')} 0s 0.5s linear
		forwards;

	@keyframes hideModal {
		0% {
			transform: scale(1);
		}
		99.9% {
			transform: scale(1);
		}
		100% {
			transform: scale(0);
		}
	}
`;
export const Background = styled.div `
	display: flex;
	width: 100%;
	position: absolute;
	top: 0px;
	left: 0px;
	overflow: hidden;
	height: 100vh;
	background-color: ${theme.colors.LM_NU80T};
	transition: opacity 300ms ease-out;
	opacity: ${({ show }) => (show ? 1 : 0)};
	justify-content: center;
	align-items: center;
`;
export const Panel = styled.div `
	display: flex;
	width: fit-content;
	height: fit-content;
	position: absolute;
	min-width: 500px;
	transform: ${({ show, topMargin }) => show
    ? `translateY(${100 - Number(topMargin)}vh)`
    : 'translateY(100vh)'};
	z-index: 1020;
	bottom: 0px;
	border-radius: 16px 16px 0px 0px;
	transition: ${(props) => {
    var _a;
    return `${((_a = props.className) === null || _a === void 0 ? void 0 : _a.includes('mounted'))
        ? 'transform 200ms'
        : ''}`;
}};
	transition-timing-function: cubic-bezier(.4,0,.6,1);
	overflow: hidden;
	flex-direction: column;
	background-color: white;
	@media screen and (max-width: ${() => theme.breakpoints.sm.min}) {
		height: calc(${({ topMargin }) => topMargin}% - 136px); /* the size of the 2 header and footer bars */
		/* fix bottom bar overlapping panel on small screen apple device */
		min-height: -webkit-fill-available;
		min-width: 100vw;
	};
	@media screen and (min-width: ${() => theme.breakpoints.sm.min}) {
		position: relative;
		transform: ${(props) => props.show ? 'translateY(0%)' : 'translateY(100vh)'};
		border-radius: 16px;
		transition: ${(props) => {
    var _a;
    return `${((_a = props.className) === null || _a === void 0 ? void 0 : _a.includes('mounted'))
        ? 'opacity 300ms ease-out'
        : ''}`;
}};
	};
`;
export const HeaderContainer = styled.div `
	display: flex;
	justify-content: space-between;
	width: 100%;
	position: absolute;
	padding: 0px 16px;
	height: 68px;
	align-items: center;
	top: 0px;
`;
export const Content = styled.div `
	display: flex;
	height: 100%;
	max-height: calc(${({ topMargin }) => topMargin}% - ${({ showHeaderSpace, showFooterSpace }) => showHeaderSpace && showFooterSpace ? 136 : showHeaderSpace || showFooterSpace ? 68 : 0}px);
	overflow: ${({ overflow }) => `${overflow.x} ${overflow.y}`};
	@media screen and (min-width: ${() => theme.breakpoints.sm.min}) {
		max-height: 80vh;
	}
`;
export const Title = styled.div `
	font-family: ${theme.typography.RWB110.fontFamily};
	font-weight: ${theme.typography.RWB110.fontWeight};
	font-size: ${theme.typography.RWB110.fontSize};
	letter-spacing: ${theme.typography.RWB110.letterSpacing};
	line-height: 125%;
	font-feature-settings: 'pnum' on, 'lnum' on, 'ss09' on;
	color: rgba(17, 35, 58, 1);
	;
`;
export const FooterContainer = styled.div `
	display: flex;
	justify-content: flex-end;
	width: 100%;
	position: absolute;
	padding: 0px 16px;
	height: 68px;
	align-items: center;
	bottom: calc(100% - ${({ topMargin }) => Number(topMargin)}%);
`;
export const HeaderFooterBackground = styled.div `
	min-width: 100%;
	height: 68px;
	background-color: white;
`;
export const CloseButtonWrapper = styled.div `
	z-index: 1020;
`;
export const ButtonWrapper = styled.div `
	margin-left: 10px;
`;
//# sourceMappingURL=Modal.styled.js.map